<template lang="pug">
  v-row
    v-col(cols=12)
      v-btn-toggle.mb-2(
        ).sdo-shadow
          v-btn(
            exact-path
            :to="{ name: 'ModulesStockMy' }"
          )
            v-icon.mr-1 mdi-checkbox-marked
            span Подключенные модули
          v-btn(
            exact-path
            :to="{ name: 'ModulesStock' }"
          )
            v-icon.mr-1 mdi-view-module
            span Биржа
      v-row
        v-col.grow
          v-text-field(
            v-model="searchQ.name"
            placeholder="Название модуля"
            prepend-inner-icon="mdi-magnify"
            clearable
            outlined
            filled
            rounded
          )
        v-col.shrink(v-if="isStock")
          v-btn-toggle(v-model="type").sdo-shadow
            v-btn(
              :value="1"
            )
              v-icon.mr-1 mdi-account
              span Общеобразовательные
            v-btn(
              :value="2"
            )
              v-icon.mr-1 mdi-account-arrow-up
              span Повышение квалификации
      v-row(v-if="type === 1 && isStock")
        v-col(cols=12 md=4)
          v-text-field(
            v-model="searchQ.minAge"
            label="Минимальный возврат"
            clearable
            outlined
            hide-details
            filled
            rounded
          )
        v-col(cols=12 md=4)
          v-text-field(
            v-model="searchQ.maxAge"
            label="Максимальный возврат"
            clearable
            hide-details
            outlined
            filled
            rounded
          )
        v-col(cols=12 md=4)
          v-select(
            v-model="searchQ.direction"
            :items="directions"
            label="Направленность"
            clearable
            item-text="name"
            hide-details
            item-value="id"
            outlined
            filled
            rounded
          )
    v-col(cols=12)
      router-view(
        :search-q="searchQ"
        :search-type="type"
        :directionsItems="directions"
      )
</template>

<script>
export default {
  data() {
    return {
      type: null,
      searchQ: {
        name: null,
        minAge: null,
        maxAge: null,
        direction: null,
      },
      directions: null,
    };
  },
  computed: {
    isStock() {
      return this.$route.name === 'ModulesStock';
    },
  },
  watch: {
    type() {
      this.searchQ = {};
    },
    isStock() {
      this.searchQ = {};
    },
  },
  created() {
    this.getDirections();
  },
  methods: {
    getDirections() {
      this.$rHandler(
        this.$api.system.getDirections(),
        (r) => {
          this.directions = r.data.data;
        },
      );
    },
  },
};
</script>
